import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  formLayoutWrapper: {
    width: '100%',
    minHeight: '100vh',
    height: '100%',
    backgroundColor: '#F0F2F7',
    boxSizing: 'border-box',
    padding: theme.spacing(10),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: 'unset',
      justifyContent: 'space-between',
    },
  },
  contentWrapper: {
    maxWidth: theme.spacing(209),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
    },
  },
  sliderWrapper: {
    width: '100%',
    minHeight: theme.spacing(450),
    maxWidth: theme.spacing(390),
    borderRadius: theme.spacing(5),
    overflow: 'hidden',
    padding: theme.spacing(28, 10, 30),
    background: 'transparent linear-gradient(221deg, #01B2AE 0%, #FFD6EE 100%) 0% 0% no-repeat padding-box',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 'unset',
      width: '100%',
      maxWidth: 'unset',
      minHeight: 'unset',
      padding: theme.spacing(17.5, 12, 31.5),
    },
    [theme.breakpoints.down('xs')]: {},
  },
  sliderLogoWrapper: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(12.5),

      '& svg': {
        width: '60%',
      },
    },
  },
  title: {
    textAlign: 'center',
    font: 'normal normal 900 36px/37px Roboto',
    color: '#233B58',
    letterSpacing: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '30px',
      lineHeight: '30px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '30px',
    },
  },
  preTitle: {
    textAlign: 'center',
    margin: theme.spacing(55, 0, 10),
    font: 'normal normal bold 18px/25px Roboto',
    color: '#00B2AE',

    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '14px',
      marginTop: 'unset',
    },
  },
}));
